import { useMemo } from 'react';

import { RenderStatus } from 'services/finalcut.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { ModalEnum, setModal } from 'components/app/_mediator/app.slice';
import { fcStripePlans } from 'components/app/finalcuts/_mediator/fc-data.slice';
import { IntroKeys } from 'components/app/intro/intro-keys';

import { AppButton } from 'components/app/app-components/app-button/app-button';

export const FcUpgrade = () => {
  const fcStatus = useAppSelector((state) => state.fc__data.fcStatus);
  const stripePlans = useAppSelector(fcStripePlans);
  const dispatch = useAppDispatch();

  const tipTitle = useMemo(() => {
    switch (fcStatus) {
      case RenderStatus.pending:
      case RenderStatus.processing:
        return 'Final cut is rendering...';
      case RenderStatus.error:
        return 'Unable to upgrade: Resolve final cut errors first';
      case RenderStatus.rendered:
        return !stripePlans.length
          ? 'Final cut has been upgraded to the highest plan tier'
          : 'Upgrade to remove watermarks or increase resolution';
    }
  }, [fcStatus]);

  return (
    <AppButton
      disabled={fcStatus !== RenderStatus.rendered || !stripePlans.length}
      onClick={() => dispatch(setModal(ModalEnum.fcUpgrade))}
      data-intro={IntroKeys.fcUpgrade}
      tip={tipTitle}
      tipPosition="bottom"
    >
      Upgrade
    </AppButton>
  );
};
